"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceResultRow = void 0;
const adaptivecards_1 = require("adaptivecards");
const components_1 = require("../../_shared/components");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const ChoiceResultRow = (label, votes, totalVotes, names, anonymityLevel, applicationType, condensedNames = false, isUserVote = false, npsCategory) => {
    const container = new adaptivecards_1.Container();
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: label,
        wrap: true,
        weight: adaptivecards_1.TextWeight.Bolder,
    }));
    const resultCountColumnSet = CardHelper_1.CardHelper.create(adaptivecards_1.ColumnSet, { spacing: adaptivecards_1.Spacing.None });
    const choicePercentage = totalVotes > 0 ? (votes / totalVotes) * 100 : 0;
    const barColumn = CardHelper_1.CardHelper.create(adaptivecards_1.Column, {
        width: "stretch",
        verticalContentAlignment: adaptivecards_1.VerticalAlignment.Center,
    });
    barColumn.addItem((0, components_1.ProgressBar)(applicationType, choicePercentage, undefined, npsCategory));
    const countColumn = CardHelper_1.CardHelper.create(adaptivecards_1.Column, { width: "auto" });
    countColumn.addItem(getPercentTextBlock(choicePercentage, votes));
    resultCountColumnSet.addColumn(barColumn);
    resultCountColumnSet.addColumn(countColumn);
    container.addItem(resultCountColumnSet);
    if (anonymityLevel === "none" && names.length > 0) {
        const MAX_NAMES = 3;
        container.addItem(getNamesRow(names, condensedNames, MAX_NAMES, isUserVote));
    }
    return container;
};
exports.ChoiceResultRow = ChoiceResultRow;
function getPercentTextBlock(percentage, count) {
    return CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `${Math.round(percentage)}% (${count})`,
        weight: adaptivecards_1.TextWeight.Bolder,
    });
}
function getNamesRow(names, condensedNames, maxNames, isUserVote) {
    const namesLine = !condensedNames || names.length <= maxNames
        ? names.join(", ")
        : `${names.slice(0, maxNames).join(", ")} + ${names.length - maxNames} more`;
    return CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: isUserVote ? `✔️ ${namesLine}` : namesLine,
        weight: adaptivecards_1.TextWeight.Lighter,
        spacing: adaptivecards_1.Spacing.None,
        size: adaptivecards_1.TextSize.Small,
        color: isUserVote ? adaptivecards_1.TextColor.Accent : undefined,
        wrap: true,
    });
}
//# sourceMappingURL=ChoiceResultRow.js.map